import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import logo from "../../../Assets/footer/logo.svg";
// import Fb from "../../../Assets/footer/Fb.svg";
// import Insta from "../../../Assets/footer/Insta.svg";
// import LinkedIn from "../../../Assets/footer/LinkedIn.svg";
// import Youtube from "../../../Assets/footer/Youtube.svg";
// import right from "../../../Assets/footer/right.svg";
// import Scanner from "../../../Assets/footer/Scanner.png";
// import Scanner1 from "../../../Assets/footer/Scanner1.png";

function Footer({ onAboutClick, onHomeClick, onNewsClick }) {
  const navigate = useNavigate();
  const scrollWithOffset = (id, offset = 100) => {
    const element = document.getElementById(id);
    if (element) {
      const y =
        element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className="flex gap-[70px] md:flex-row justify-center flex-col pt-[47px] md:px-[80px] px-[20px] md:pb-[50px] pb-[30px] bg-white">
        <div className=" w-full">
          <div className="flex md:justify-start justify-center">
            <img
              src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/logo-footer-compressed.png"
              className="h-[100px] w-[80px]"
              alt=""
            />
          </div>
          <div className="flex justify-between md:flex-row flex-col md:gap-0 gap-[20px] pt-[30px]">
            <div>
              <h6 className="font-[700] font-satoshi md:text-start text-center text-[20px] mb-0 pb-[20px] leading-[24px] uppercase text-[#1B2E3F]">
                Quick Links
              </h6>
              <div className="flex flex-col md:items-start items-center gap-[20px]">
                {/* <Link
                  to="/"
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                >
                  Home
                </Link> */}
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    onHomeClick();
                  }}
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                >
                  Home
                </Link>

                {/* <Link
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                  to="/"
                >
                  About us
                </Link> */}
                {/* <a
                  href="#about"
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                >
                  About us
                </a> */}
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    onAboutClick();
                  }}
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                >
                  About us
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center md:items-start text-center md:text-start">
              <h6 className="font-[700] font-satoshi text-[20px] mb-0 pb-[20px] leading-[24px] uppercase text-[#1B2E3F]">
                Links
              </h6>

              <div className="flex flex-col items-center md:items-start gap-[20px]">
                <Link
                  to="/service-page"
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                >
                  Services
                </Link>
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    onNewsClick();
                  }}
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] no-underline"
                >
                  News
                </Link>
              </div>
            </div>

            <div>
              <h6 className="font-[700] md:text-start text-center font-satoshi text-[20px] mb-0 pb-[20px] leading-[24px] uppercase text-[#1B2E3F]">
                Contact Us
              </h6>
              <div className="flex flex-col md:items-start items-center gap-[20px]">
                <p className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] mb-3">
                  +91 7800 784700
                </p>
              </div>
              <div className="flex flex-col md:items-start items-center gap-[20px]">
                <a
                  href="mailto:info@claimpro.in"
                  className="font-[400] font-satoshi text-[16px] leading-[20px] text-[#000000] mb-0"
                >
                  info@claimpro.in
                </a>
              </div>
            </div>
          </div>

          <hr className="bg-[#00000033] my-[2rem]" />
          <div className="w-full flex flex-col gap-4 md:gap-6 items-center">
            <div className="w-full flex justify-between text-[#21A6E9] px-1 py-2 md:px-0 mb-2">
              <Link
                to="/terms-of-use"
                className="font-[400] font-satoshi text-[16px] leading-[20px] no-underline"
              >
                Terms & Conditions
              </Link>
              <Link
                to="/privacy-policy"
                className="font-[400] font-satoshi text-[16px] leading-[20px] no-underline"
              >
                Privacy Policy
              </Link>
            </div>
          </div>

          <div className="w-full flex flex-col md:flex-row items-center justify-between gap-4 mt-2">
            {/* Left QR Scanner */}
            <div className="flex justify-center md:justify-end w-full md:w-auto">
              <div className="bg-[#21A6E9] rounded-[12px] p-2 flex flex-col items-center w-[120px]">
                <div className="bg-white rounded-md p-1">
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Scanner1.png"
                    alt="QR Code 2"
                    className="w-[86px] h-auto md:w-[100px] object-contain"
                  />
                </div>
                <p className="text-white text-center font-medium text-[7px] md:text-[9px] mt-1 leading-tight">
                  Download <br />
                  <span className="font-semibold">"ClaimPro Assist"</span>
                  <br />
                  Android App
                </p>
              </div>
            </div>

            {/* Center Social Icons + Text */}
            <div className="flex flex-col items-center justify-center text-center">
              <div className="flex gap-4 mb-3 flex-wrap justify-center">
                <a
                  href="https://www.facebook.com/p/BVC-ClaimPro-Assist-61559865797607/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Fb.svg"
                    alt="Facebook"
                  />
                </a>
                <a
                  href="https://www.instagram.com/bvc_claimpro_assist_official/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Insta.svg"
                    alt="Instagram"
                  />
                </a>
                <a
                  href="https://in.linkedin.com/company/bvc-claim-pro-assist"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/LinkedIn.svg"
                    alt="LinkedIn"
                  />
                </a>
                <a
                  href="https://www.youtube.com/watch?v=qmUlSNG5xKg"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Youtube.svg"
                    alt="YouTube"
                  />
                </a>
              </div>
              <p className="font-[400] font-satoshi text-[12px] leading-[26px] text-[#0A0119]">
                © 2025 BCV ClaimPro Assist Private Limited.
              </p>
            </div>

            {/* Right QR Scanner */}
            <div className="flex justify-center md:justify-end w-full md:w-auto">
              <div className="bg-[#21A6E9] rounded-[12px] p-2 flex flex-col items-center w-[120px]">
                <div className="bg-white rounded-md p-1">
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Scanner.png"
                    alt="QR Code 2"
                    className="w-[86px] h-auto md:w-[100px] object-contain"
                  />
                </div>
                <p className="text-white text-center font-medium text-[7px] md:text-[9px] mt-1 leading-tight">
                  Download <br />
                  <span className="font-semibold">"ClaimPro Partner"</span>
                  <br />
                  Android App
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-[496px] w-full bg-[#21A6E9] rounded-[10px] py-[46px] md:px-[56px] px-[20px]">
          <h6 className="text-center mb-0 font-[500] font-satoshi md:text-[31px] text-[24px] md:leading-[52.4px] leading-[30px] text-[#FFFFFF] pb-[25px]">
            Why Choose ClaimPro Assist?
          </h6>
          <p className="mb-0 font-[400] font-satoshi md:text-[18px] text-[16px] md:leading-[30px] leading-[20px] text-center text-[#FFFFFF] pb-[1rem]">
            Reliable Support When You Need It Most
          </p>
          <p className="mb-0 font-[400] font-satoshi md:text-[20px] text-[16px] md:leading-[30px] leading-[20px] text-center text-[#FFFFFF] pb-[46px]">
            Join our extended family and receive prompt, professional assistance
            after an unexpected vehicle accident—so you can get back on the road
            with peace of mind
          </p>
          <Link to="/LoginPage">
            <div className="bg-[#21A6E9] border border-white flex items-center justify-between rounded-full pl-[0.5rem] pr-[0.5rem] py-2 max-w-[180px] w-full mx-auto">
              <button className="font-satoshi font-[400] text-[4vw] sm:text-[3vw] md:text-[18px] leading-tight sm:leading-snug text-white pr-2 mr-2 ml-2">
                Join Now
              </button>
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/right.svg"
                alt="arrow"
                className="h-[6vw] w-[6vw] sm:h-[5vw] sm:w-[5vw] md:h-[40px] md:w-[40px]"
              />
            </div>
          </Link>
        </div>
      </footer>
    </>
  );
}

export default Footer;
